export default {"src":"/_next/static/media/EQR.2112a7a4.svg","height":18,"width":18};